import React, { useState } from 'react';
import { SafeSuspense } from 'utils/SafeSuspense';
import { CloseMapButton } from 'components/navigation/user-mobile-navigation/CloseMapMobileButton';
import Legend from './Legend';
import * as Styled from './styled';
import MapListToggle from 'screens/DeveloperPage/components/map-list-toggle';
import { ShowAt, useScreenBreakpoint } from 'consts/breakpoints';
import { PoiId } from 'utils/entities';
import { Section } from 'components/navigation/subheader/SectionsNavigation';
import { projectFilterSections } from 'screens/DeveloperPage/helpers';

const ConnectedMap = React.lazy(() => import('./ConnectedMap'));

interface DeveloperMapProps {
  showMobileMap: boolean;
  setShowMobileMap: (val: boolean) => void;
  activeSection: Section;
  hasPaddingBottom: boolean;
}

const DeveloperMap: React.FC<DeveloperMapProps> = ({ showMobileMap, setShowMobileMap, activeSection, hasPaddingBottom }) => {
  const [ activeProject, setActiveProject ] = useState<PoiId>(null);
  const closeMobileMap = () => {
    setShowMobileMap(false);
    setActiveProject(null);
  };
  const isMobile = useScreenBreakpoint() === 1;
  const hideToggle = isMobile && activeProject || !projectFilterSections.has(activeSection);

  return (
    <>
      <Styled.Wrapper noTopMargin showMobileMap={showMobileMap}>
        <Styled.MapWrapper>
          <link href="https://api.tiles.mapbox.com/mapbox-gl-js/v1.9.1/mapbox-gl.css" rel="stylesheet" />
          <SafeSuspense>
            <ConnectedMap
              activeProject={activeProject}
              setActiveProject={setActiveProject}
            />
            <Legend />
            {showMobileMap ? (
              <CloseMapButton onClose={closeMobileMap} />
            ) : null}
          </SafeSuspense>
        </Styled.MapWrapper>
      </Styled.Wrapper>
      {hideToggle ? null : (
        <ShowAt to={2}>
          <MapListToggle showMap={showMobileMap} setShowMap={setShowMobileMap} hasPaddingBottom={hasPaddingBottom} />
        </ShowAt>
      )}
    </>
  );
};

export default DeveloperMap;
